import { NpAppointmentType, NpBookableSessionType } from '../../models/calendar/CalendarV2'

// Relative to the `/services` base URL used by both web and mobile
export const NP_AVAILABLE_TIMES_PATH = '/v2/calendar/available-times'
export const getNpScheduleSessionsPath = (userLyraId: string) => `/v2/calendar/${userLyraId}/schedule-sessions`
export const getNpSessionsPath = (userLyraId: string) => `/v1/np/calendar/${userLyraId}/sessions`

// TODO: replace with the provider the member is booking with once that data is available, or omit it for pooled scheduling
export const TEMP_NP_PROVIDER_LYRA_ID = '2d8ad4d0-3fd7-454e-bb10-4bd1dfc7f650'

// TODO: remove once the available-times endpoint supports pooled scheduling (omitting providerLyraId)
export const TEMP_NP_IN_PERSON_PROVIDER_LYRA_ID = '2d8ad4d0-3fd7-454e-bb10-4bd1dfc7f650'

// TODO: remove once NP testing address collection is wired up
export const TEMP_NP_MEMBER_ADDRESS = '123 Market Street, San Francisco, CA'

// TODO: remove once the actual user's postal code is available
export const TEMP_NP_POSTAL_CODE = '94080'

// Booking window in days from today (the day the member is booking). Each appointment type will get its own window;
// clinical intake must be booked at least 7 days out and no more than 30 days out.
// TODO: add windows for testing sessions, which are relative to the prior appointment
export const NP_CLINICAL_INTAKE_BOOKING_WINDOW = { minDaysFromToday: 7, maxDaysFromToday: 30 }

/**
 * How far out each NP appointment may be booked, in days from its anchor date:
 * - clinical intake: from today
 * - testing session 1: from the clinical intake date
 * - testing session 2: from the testing session 1 date
 * The backend enforces the same gaps (SCHEDULING_RULE_VIOLATION); these only shape the availability window requested.
 */
export const NP_BOOKING_WINDOWS: Record<NpBookableSessionType, { minDays: number; maxDays: number }> = {
  [NpAppointmentType.NP_CLINICAL_INTAKE]: { minDays: 7, maxDays: 30 },
  [NpAppointmentType.NP_TESTING_SESSION_1]: { minDays: 7, maxDays: 21 },
  [NpAppointmentType.NP_TESTING_SESSION_2]: { minDays: 3, maxDays: 14 },
}

export const NP_SESSION_TYPES = {
  NP_CLINICAL_INTAKE: 'np_clinical_intake',
  NP_TESTING_SESSION_1: 'np_testing_session_1',
  NP_TESTING_SESSION_2: 'np_testing_session_2',
  NP_POST_SESSION: 'np_post_session',
} as const
